// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25v_9","title":"styles_title__1XsK1"};